import React, { createContext, useContext, useState, useCallback } from 'react';

const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        limit: 10
    });

    const [searchTimeout, setSearchTimeout] = useState(null);

    const handleSearch = useCallback((fetchFunction) => (e) => {
        const value = e.target.value;
        setSearch(value);

        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        const timeoutId = setTimeout(() => {
            fetchFunction(1, pagination.limit, value);
        }, 15000);

        setSearchTimeout(timeoutId);
    }, [pagination.limit, searchTimeout]);

    const handleLimitChange = useCallback((e) => {
        const newLimit = parseInt(e.target.value);
        setPagination(prev => ({ ...prev, limit: newLimit, currentPage: 1 }));
    }, []);


    return (
        <GlobalStateContext.Provider value={{
            loading,
            setLoading,
            search,
            setSearch,
            pagination,
            setPagination,
            searchTimeout,
            setSearchTimeout,
            handleSearch,
            handleLimitChange,

        }}>
            {children}
        </GlobalStateContext.Provider>
    );
};

export const useGlobalState = () => {
    const context = useContext(GlobalStateContext);
    if (!context) {
        throw new Error('useGlobalState must be used within a GlobalStateProvider');
    }
    return context;
};